import React, {useEffect, useRef, useState} from 'react';
import parse from 'html-react-parser';
import {useTranslation} from "react-i18next";
import {errorRandomReplace} from "../../../util/Validation";

const classNames = require('classnames');

const OnboardCreditCardName = (props) => {
    const {t} = useTranslation();

    const {
        error,
        value,
        onChange
    } = props;
    const inputRef = useRef();

    const length = 50;
    const [mValue, setMValue] = useState(value != null ? value : "");
    const [mError, setMError] = useState(error);

    useEffect(() => {
        setMError(error);
    }, [error]);

    useEffect(() => {
        setMValue(value != null ? value : "");
    }, [value]);

    const handleChange = (val) => {
        let text = val.target.value;
        text = text.replace(/[\p{Emoji}\u200D\uFE0F0-9]/gu, '');

        if (text.length > length) return;

        if (error !== undefined) {
            setMError(null);
        }

        setMValue(text);
        if (onChange !== undefined)
            onChange(text);
    }

    useEffect(() => {
        if (mValue !== undefined && mValue != null && mValue.length > 0) {
            inputRef.current.value = parse(mValue);
        }
    }, [])


    const setClassName = () => {
        return classNames({
            'onboard-credit-card-inp-error': mError
        })
    }

    return (
        <div className="onboard-credit-card-root">
            <div className="onboard-credit-card-inp">
                <input ref={inputRef}
                       type="text"
                       placeholder="&nbsp;"
                       value={parse(mValue)}
                       onChange={(e) => handleChange(e)}
                       className={setClassName()}
                       id="cardHolder"
                       autoComplete="cc-name"
                >
                </input>
                <div className={"onboard-credit-card-label " + (mError ? 'onboard-credit-card-inp-error-label' : '')}>
                    {t('payment.credit_card.name_surname')}
                </div>
                <span className="onboard-credit-card-focus-bg"></span>
                {mError && (<div className="onboard-credit-card-error-hint">{errorRandomReplace(mError)}</div>)}
            </div>
        </div>
    )
};

export default OnboardCreditCardName;
